import
  React
from 'react';

export default ({
  size = '24'
}) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="#282828"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.7937 15.5C14.7937 15.5 17.5987 15.6075 18.6925 15.125C20.2448 14.4217 21.3057 12.9456 21.4775 11.25C21.6412 9.61378 20.895 7.81628 19.485 6.94628C18.7837 6.51503 17.965 6.34003 17.1462 6.26878C16.6791 6.25619 16.2117 6.27708 15.7475 6.33128C15.6173 5.91667 15.4386 5.51891 15.215 5.14628C14.314 3.64779 12.7495 2.67174 11.0075 2.52128C9.3025 2.39746 7.64169 3.09954 6.5425 4.40878C6.01186 5.04328 5.63116 5.78929 5.42875 6.59128C5.375 6.80378 5.26875 7.39628 5.26875 7.39628C4.72163 7.5718 4.21655 7.85817 3.785 8.23753C2.47125 9.41253 2.15125 11.42 2.88625 13C3.55375 14.435 4.9875 15.5 6.5825 15.5H9.2075"
    />
    <path
      d="M12 19V8.5"
      stroke="#282828"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#282828"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.75 12L12 8.5L15.25 12"
    />
  </svg>
);